/**
 * TOP VIDEO GALLERY
 * 
 * This gallery feeds the homepage hero video player.
 * Videos play in the order they appear in this list.
 * 
 * To add new videos:
 * 1. Upload videos to the platform
 * 2. Use the command: ADD TO TOP VIDEO GALLERY
 * 3. The system will automatically append new videos here
 */

export const TOP_VIDEO_GALLERY = [
  {
    id: 1,
    url: "https://customer-assets.emergentagent.com/job_992976b8-cda7-4966-be64-71ea3931395e/artifacts/fvh3rxcq_1.mp4",
    title: "Hero Video 1"
  },
  {
    id: 2,
    url: "https://customer-assets.emergentagent.com/job_992976b8-cda7-4966-be64-71ea3931395e/artifacts/ipslerzn_2.mp4",
    title: "Hero Video 2"
  },
  {
    id: 3,
    url: "https://customer-assets.emergentagent.com/job_992976b8-cda7-4966-be64-71ea3931395e/artifacts/5h202xi0_3.mp4",
    title: "Hero Video 3"
  },
  {
    id: 4,
    url: "https://customer-assets.emergentagent.com/job_992976b8-cda7-4966-be64-71ea3931395e/artifacts/k156go83_4.mp4",
    title: "Hero Video 4"
  },
  {
    id: 5,
    url: "https://customer-assets.emergentagent.com/job_992976b8-cda7-4966-be64-71ea3931395e/artifacts/pd8m4htr_5.mp4",
    title: "Hero Video 5"
  },
  {
    id: 6,
    url: "https://customer-assets.emergentagent.com/job_992976b8-cda7-4966-be64-71ea3931395e/artifacts/id5ps5zp_6.mp4",
    title: "Hero Video 6"
  },
  {
    id: 7,
    url: "https://customer-assets.emergentagent.com/job_992976b8-cda7-4966-be64-71ea3931395e/artifacts/i6gd0k0u_7.mp4",
    title: "Hero Video 7"
  },
  {
    id: 8,
    url: "https://customer-assets.emergentagent.com/job_992976b8-cda7-4966-be64-71ea3931395e/artifacts/eyxn43xb_8.mp4",
    title: "Hero Video 8"
  },
  {
    id: 9,
    url: "https://customer-assets.emergentagent.com/job_992976b8-cda7-4966-be64-71ea3931395e/artifacts/9rzr47bp_9.mp4",
    title: "Hero Video 9"
  },
  {
    id: 10,
    url: "https://customer-assets.emergentagent.com/job_992976b8-cda7-4966-be64-71ea3931395e/artifacts/x8v4cfjr_10.mp4",
    title: "Hero Video 10"
  }
];

// Fallback poster image - first frame of Hero Video 1 for seamless transition
export const HERO_FALLBACK_IMAGE = "/images/optimized/hero-poster.webp";
